const methods = {
  ein(val) {
    val = val.toString();
    if (!val.length === 9) return val;
    return `${val.substring(0, 2)}-${val.substring(2)}`;
  }
};

export default methods;
